import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    content: $props.content,
    placement: $props.placement,
    effect: $props.effect,
    visible: $data.show_tip
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Icon, {
        stroke: "var(--gray-700)",
        icon: "clipboard",
        "stroke-width": "1",
        width: "1.6rem",
        height: "1.6rem",
        class: "pointer copy",
        onClick: _cache[0] || (_cache[0] = $event => ($options.copy()))
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["content", "placement", "effect", "visible"]))
}